/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum VideoDestinationFormat {
    Default = 0,
    Mjpeg = 1,
    AxisMediaStreamLibrary = 6,
    AxisMediaStreamLibraryMjpeg = 9,
    RtspWebRtc = 11,
}
